import { useMutation } from '@tanstack/react-query';

import {
  type RequestRestrictedPromoPayload,
  type RequestRestrictedPromoResponse,
  requestRestrictedPromo,
} from '~/services/PromoService';

export function useRequestRestrictedPromo() {
  return useMutation<RequestRestrictedPromoResponse, Error, RequestRestrictedPromoPayload>({
    mutationFn: requestRestrictedPromo,
    retry: false,
  });
}
